import type { IconData } from '@stacksjs/iconify-core'

export const shoppingShippingDiscountCoupon: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M28.185 12.19v1.53h3.05V6.1h-1.52v6.09zm1.53 7.62v6.1h1.52v-7.62h-3.05v1.52zm-27.43 6.1h27.43v1.52H2.285Zm24.38-12.19h1.52v4.57h-1.52Zm-4.57 3.04h-3.05v1.53h-1.52v3.05h1.52v1.52h3.05v-1.52h1.52v-3.05h-1.52zm-1.52-6.09h-1.53v1.52h-1.52v1.53h-1.53v1.52h-1.52v1.52h-1.52v1.53h-1.53v1.52h-1.52v1.53h-1.52v1.52h3.04v-1.52h1.53v-1.53h1.52v-1.52h1.52v-1.53h1.53v-1.52h1.52v-1.52h1.53v-1.53h1.52v-1.52h1.52V9.15h-3.04zm-10.67 4.57h3.05v-1.52h1.52v-3.05h-1.52V9.15h-3.05v1.52h-1.52v3.05h1.52zm-6.1-1.52h1.53v4.57h-1.53Zm-1.52-9.15h27.43V6.1H2.285Zm0 7.62V6.1H.765v7.62h3.04v-1.53zm0 7.62h1.52v-1.52H.765v7.62h1.52z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default shoppingShippingDiscountCoupon
